import { useEffect, useState } from 'react';
import PriorityOutputs1 from '../PriorityOutputs1';
import PriorityOutputs2 from '../PriorityOutputs2';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import EcoSpace from 'eco-design/base/eco-space';
import getLocal from 'eco-design-reliance/getLocal';

interface PriorityOutputsProps {
    pageType: 'max' | 'ultra';
}

const PriorityOutputs: React.FC<PriorityOutputsProps> = ({ pageType } = { pageType: 'max' }) => {
    const { t } = useLang('PriorityOutputs');
    const [load, setLoad] = useState(true);
    const { locale = '', pathname } = getLocal();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // const scenePriorityOutputs = AniContainer.create({
            //     triggerElement: '.priority-outputs-section',
            //     triggerHook: 1,
            //     onEnter: () => setLoad(true),
            // });
            // return () => {
            //     scenePriorityOutputs.destroy();
            // };
        }
    }, []);

    return (
        <section
            className={`${styles.PriorityOutputs} priority-outputs-section GtmModuleData-section ${
                pathname === '/delta-3-max-plus-portable-power-station' && locale === 'de' ? 'no-sticky' : ''
            }`}
            id="PriorityOutputs"
            data-section-id={'d3m-priority-outputs'}
            data-section-title={t('title')}
        >
            <div className="position-block" id="PriorityOutputsBlock"></div>
            <div className={`sticky`}>
                <div className="box1 box">
                    <PriorityOutputs1 pageType={pageType} />
                </div>
            </div>
            {pathname !== '/delta-3-max-plus-portable-power-station' ||
                (locale !== 'de' && (
                    <>
                        <EcoSpace hPc="50vh" hPad="0" hH5="0" />
                        <div className="box2 box">
                            <PriorityOutputs2 load={load} pageType={pageType} />
                        </div>
                    </>
                ))}
        </section>
    );
};

export default PriorityOutputs;
